import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { Btn, H5, Image, LI, P, UL } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";

const BlogBoxDetails = () => {
  return (
    <Col sm="12">
      <Card className="blog-detail">
        <CardHeader className="pb-0 border-0">
          <Image className="img-fluid w-100" src={dynamicImage("blog/blog-detail.jpg")} alt="" />
        </CardHeader>
        <CardBody>
          <H5 className="txt-primary">Exploring the Intersection of Technology and Business</H5>
          <div className="post-social">
            <UL className="d-flex align-items-center simple-list flex-row">
              <LI>25 March 2025</LI>
              <LI><i className="fa fa-user mx-1" />Admin</LI>
              <LI><i className="fa fa-comments mx-1" />12 Comments</LI>
            </UL>
          </div>
          <div className="blog-share">
            <Btn color="primary" className="me-2"><i className="fa fa-share-alt" /></Btn>
            <Btn color="secondary"><i className="fa fa-ellipsis-v" /></Btn>
          </div>
          <P>Investigate how technology has empowered entrepreneurs to launch and scale their businesses more efficiently, from e-commerce platforms and mobile apps to digital payment systems and online marketing tools. Delve into the evolving landscape of cybersecurity threats and the importance of robust cybersecurity measures for safeguarding sensitive business data, maintaining customer trust, and mitigating cyber risks. Businesses are leveraging these technologies to enhance operations, improve efficiency, and drive innovation, the responsibility of businesses to use technology ethically and responsibly.</P>
          <div className="blog-quote">
            <i className="fa fa-quote-left" />
            <P>Explore how businesses are undergoing digital transformation journeys to adapt to the digital age, streamline processes, and deliver enhanced customer experiences. Topics may include cloud computing, data analytics, and digital marketing strategies. Discuss the importance of data-driven decision-making processes in business, highlighting the use of big data analytics.</P>
          </div>
          <P>Consider the ethical and social implications of technological advancements in business, including privacy concerns, algorithmic bias, digital divide issues, and the responsibility of businesses to use technology ethically and responsibly. The importance of data-driven decision-making processes in business, highlighting the use of big data analytics, data visualization tools, and business intelligence platforms to extract actionable insights and drive strategic outcomes.</P>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BlogBoxDetails;
